import { cn } from '@/shared/lib'
import { Chip } from '@/shared/ui/chip'

// Привязка звонка к хабу: имена приезжают вместе со встречей (проекция хаба),
// id остаётся фолбэком, пока запись не досинкана. Форма покрывает и summary,
// и detail — обе несут одни и те же четыре поля.
export interface MeetingRefsSource {
  companyId?: string | undefined
  projectId?: string | undefined
  companyName?: string | undefined
  projectName?: string | undefined
}

interface MeetingRefsProps {
  meeting: MeetingRefsSource
  /** Заказчику компания не нужна: она у него всегда своя и в контекст не добавляет. */
  hideCompany?: boolean
  /** С обработчиком чип становится фильтром списка; без него — просто контекст. */
  onCompany?: (companyId: string) => void
  onProject?: (projectId: string) => void
  className?: string
}

// Где идёт разговор: компания и проект хаба. Нужны везде, где человек решает,
// о чём встреча, — в списке, на карточке, перед входом и в самом звонке.
export function MeetingRefs({
  meeting,
  hideCompany = false,
  onCompany,
  onProject,
  className,
}: MeetingRefsProps) {
  const companyId = hideCompany ? undefined : meeting.companyId
  const projectId = meeting.projectId
  if (!companyId && !projectId) return null

  const companyName = meeting.companyName ?? companyId
  const projectName = meeting.projectName ?? projectId

  return (
    <div className={cn('flex flex-wrap items-center gap-1.5', className)}>
      {companyId && (
        <RefChip
          label={`Компания: ${companyName}`}
          actionLabel={`Показать встречи компании ${companyName}`}
          {...(onCompany ? { onSelect: () => onCompany(companyId) } : {})}
        />
      )}
      {projectId && (
        <RefChip
          label={`Проект: ${projectName}`}
          actionLabel={`Показать встречи проекта ${projectName}`}
          {...(onProject ? { onSelect: () => onProject(projectId) } : {})}
        />
      )}
    </div>
  )
}

function RefChip({
  label,
  actionLabel,
  onSelect,
}: {
  label: string
  actionLabel: string
  onSelect?: () => void
}) {
  if (!onSelect) return <Chip variant="soft">{label}</Chip>
  return (
    <button type="button" aria-label={actionLabel} onClick={onSelect}>
      <Chip variant="soft" className="transition-colors hover:text-text-primary">
        {label}
      </Chip>
    </button>
  )
}
